import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="AlertTriangle" size={48} className="text-primary" />
          </div>
          <h1 className="text-6xl font-heading font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl font-heading font-semibold text-text-primary mb-4">
            Página no encontrada
          </h2>
          <p className="text-text-secondary mb-8">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/homepage"
            className="inline-flex items-center justify-center space-x-2 bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-primary/90 nav-transition"
          >
            <Icon name="Home" size={20} />
            <span>Volver al inicio</span>
          </Link>
          
          <div className="text-sm text-text-secondary">
            <p>¿Necesitas ayuda? Contáctanos:</p>
            <p className="font-mono text-primary">+506 8888-8888</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;